import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LegalTermsRestService } from "src/providers/legal-terms-restservice";

@Component({
  selector: "app-legal-terms",
  template: `
    <div style="padding-bottom: 300px;" [innerHTML]="legalContent"></div>
  `,
  styleUrls: ["./legal-terms.component.scss"],
})
export class LegalTermsComponent implements OnInit {
  legalContent: string;

  constructor(
    private _legalTermsRestService: LegalTermsRestService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    let language = this.translateService.getLangs()[0];
    this._legalTermsRestService.getLegalContent(language).subscribe((content) => {
      this.legalContent = content;
    })
  }

}
